import { flsModules } from "../files/modules.js";

import Swiper from "swiper";
import { Thumbs, Navigation, Grid} from "swiper/modules";

import { Fancybox } from "@fancyapps/ui";

document.addEventListener("DOMContentLoaded", () => {
  const mainEl = document.querySelector(".auto-main");
  if (!mainEl) return;

  const thumbsSwiper = new Swiper(".auto-thumbs", {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    slideToClickedSlide: true,
  });

  new Swiper(".auto-main", {
    modules: [Thumbs],
    spaceBetween: 10,
    thumbs: {
      swiper: thumbsSwiper,
      autoScrollOffset: 1,
    },
  });
  Fancybox.bind("[data-fancybox='auto-gallery']", {
    groupAll: true,
  });
});

// Видео
document.addEventListener("DOMContentLoaded", () => {
  const sliderEl = document.querySelector(".reviewsSwiper");
  if (!sliderEl) return;

  new Swiper(".reviewsSwiper", {
    modules: [Navigation, Grid],

    slidesPerView: 3,
    spaceBetween: 24,

    grid: {
      rows: 2,
      fill: "row",
    },

    slidesPerGroup: 6,
    loop: false,
    loopAddBlankSlides: true,
    watchOverflow: true,

    navigation: {
      nextEl: ".reviews-slider .swiper-button-next",
      prevEl: ".reviews-slider .swiper-button-prev",
    },

    breakpoints: {
      320: {
        slidesPerView: 1,
        grid: { rows: 2 },
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: 2,
        grid: { rows: 1 },
        slidesPerGroup: 2,
      },
      1200: {
        slidesPerView: 3,
        grid: { rows: 2 },
        slidesPerGroup: 6,
      },
    },
  });
});

Fancybox.bind("[data-fancybox='reviews']", {
  Html: { video: { autoplay: true } },
});


// Cекция услуг

document.addEventListener("DOMContentLoaded", () => {
  const forSlider = document.querySelector(".for__slider");
  if (!forSlider) return;

  new Swiper(".for__slider", {
    modules: [Navigation],

    slidesPerView: 3,
    spaceBetween: 24,
    speed: 600,

    navigation: {
      nextEl: ".for-next",
      prevEl: ".for-prev",
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2.2,
      },
      1024: {
        slidesPerView: 3.3,
      }
    }
  });
});


